<template>
  <div>
    <p>
      <span style="margin-right: 10px;">时间选择：</span>
      <el-select v-model="value" placeholder="请选择" @change="onGetCommentAnalyseList">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <samp style="margin-left: 20px;">
        <!-- 月 -->
        <el-date-picker v-if="value === '0'" v-model="month" type="month" placeholder="选择月" value-format="yyyy-MM" @change="onGetCommentAnalyseList" />
        <!-- 季度 -->
        <el-select v-else-if="value === '1'" v-model="quarter" placeholder="请选择" @change="onGetCommentAnalyseList">
          <el-option v-for="item in quarter_options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <!-- 年 -->
        <el-date-picker v-else-if="value === '2'" v-model="year" type="year" placeholder="选择年" value-format="yyyy" @change="onGetCommentAnalyseList" />
      </samp>
    </p>
    <br>
    <div class="analyse_info">
      <div class="analyse_left analyse_info_detail">
        <p>门店{{ value === '0'?'当月': value === '1'?'当季':(year+'年') }}评价平均分：{{ analyseList.averageCount }}分</p>
        <p>门店{{ value === '0'?'当月': value === '1'?'当季':(year+'年') }}总评数：{{ analyseList.numCount }}</p>
      </div>
      <div class="analyse_middle analyse_info_detail">
        <p>
          <span class="analyse_num">{{ analyseList.badCount }}</span>
          <br>
          <span>差评</span>
        </p>
        <p>
          <span class="analyse_num">{{ analyseList.justCount }}</span>
          <br>
          <span>中评</span>
        </p>
        <p>
          <span class="analyse_num">{{ analyseList.goodCount }}</span>
          <br>
          <span>好评</span>
        </p>
      </div>
      <div class="analyse_right analyse_info_detail">
        <p>
          <span
            class="analyse_num"
          >{{ analyseList.technicianName || '暂无' }}</span>
          <!-- <span class="analyse_num">{{ analyseList.technicianName || '暂无' }}</span> -->
          <br>
          <span>评价最高{{ Lib.collectively() }}</span>
        </p>
      </div>
    </div>
    <br>
    <el-table v-loading="loading" :data="analyseList.assessCountDTOs" style="width: 100%">
      <el-table-column align="center" prop="technicianName" label="姓名" width="180" height="527"></el-table-column>
      <el-table-column align="center" prop="assessNum" label="评论数" width="180"></el-table-column>
      <el-table-column align="center" prop="badNum" label="差评数"></el-table-column>
      <el-table-column align="center" prop="justNum" label="中评数"></el-table-column>
      <el-table-column align="center" prop="goodNum" label="好评数"></el-table-column>
      <el-table-column align="center" prop="average" label="平均分"></el-table-column>
      <el-table-column align="center" prop="countNum" label="总分">
        <template slot="header" slot-scope="scope">
          <span>总分</span>
          <el-tooltip v-show="scope" class="item" effect="light" placement="top-start">
            <div slot="content">
              差评：{{ analyseList.badNum }} 分
              <br>
              中评：{{ analyseList.justNum }} 分
              <br>
              好评：{{ analyseList.goodNum }} 分
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination
      background
      :page-size="pageSize"
      layout="prev, pager, next, jumper"
      :total="analyseList.technicianNum"
      @current-change="handleSizeChange"
    ></el-pagination>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { getCommentAnalyseList } from './api';

export default {
  data() {
    return {
      value: '0',
      month: dayjs().format('YYYY-MM'),
      quarter: '01,03',
      year: dayjs().format('YYYY'),
      options: [
        {
          value: '0',
          label: '月'
        },
        // {
        //   value: '1',
        //   label: '季度'
        // },
        {
          value: '2',
          label: '年'
        }
      ],
      quarter_options: [
        {
          value: '01,03',
          label: '第一季度'
        },
        {
          value: '04,06',
          label: '第二季度'
        },
        {
          value: '07,09',
          label: '第三季度'
        },
        {
          value: '10,12',
          label: '第四季度'
        }
      ],
      pageNo: 1,
      pageSize: 10,
      analyseList: {
        assessCountDTOs: [
          {
            countNum: 0,
            technicianName: ''
          }
        ]
      },
      // 5.7
      loading: true,
    };
  },
  activated() {
    this.onGetCommentAnalyseList();
  },
  methods: {
    // 获取评价分析
    onGetCommentAnalyseList() {
      let beginTime = '';
      let endTime = '';
      switch (this.value) {
        case '0':
          beginTime = `${this.month}-01`;
          endTime = `${this.month}-31`;
          break;
        case '1':
          beginTime = `${dayjs().format('YYYY')
          }-${
            this.quarter.split(',')[0]
          }-01`;
          endTime = `${dayjs().format('YYYY')
          }-${
            this.quarter.split(',')[1]
          }-31`;
          break;
        case '2':
          beginTime = `${this.year}-01-01`;
          endTime = `${this.year}-12-31`;
          break;
        default:
          break;
      }

      const data = {
        beginTime,
        endTime,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      };
      this.loading = true;
      getCommentAnalyseList(sessionStorage.getItem('mainId'), data).then(
        (res) => {
          const temp = res.data;
          // if (temp.assessCountDTOs.length === 0) {
          //     temp.assessCountDTOs .push({
          //         countNum: 0,
          //         technicianName: ""
          //     }) ;
          // }

          this.analyseList = temp;
          this.loading = false;
        }
      );
    },
    handleSizeChange(val) {
      this.pageNo = Number(val);
      this.onGetCommentAnalyseList();
    }
  }
};
</script>

<style lang="less" scoped>
.analyse_info {
    display: flex;
    .analyse_info_detail {
        background-color: #f9f9f9;
        font-size: 14px;
        color: #818691;
        text-align: center;
    }
    .analyse_left {
        flex: 1;
        padding: 26px 62px;
        p:nth-child(2) {
            margin-top: 18px;
        }
    }
    .analyse_middle {
        flex: 3;
        margin: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
            flex: 4;
        }
    }
    .analyse_right {
        flex: 1;
        padding: 26px 62px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .analyse_num {
        font-size: 26px;
        color: #fd5c8c;
    }
}
</style>
